<button
  (click)="click()"
>
  {{text}}
</button>
